import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAntrepoRequest } from '../models/request/antrepo/AddAntrepoRequest';
import { GetAntrepoListPagingAndFilterRequest } from '../models/request/antrepo/GetAntrepoListPagingAndFilterRequest';

export class AntrepoService {
    static async getAntrepoList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getAntrepoList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Antrepo/getAntrepoList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAntrepoList(inputObj: GetAntrepoListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportAntrepoList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Antrepo/exportAntrepoList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoListPagingAndFilter(inputObj: GetAntrepoListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetAntrepoListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Antrepo/GetAntrepoListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addAntrepo(inputObj: AddAntrepoRequest) {
        try {
            console.log('SERVICE CALL - AddAntrepo', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Antrepo/AddAntrepo', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteAntrepo(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteAntrepo', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Antrepo/deleteAntrepo', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getAntrepoById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Antrepo/getAntrepoById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}